import { fetchCreate, fetchNext } from '../services/api'
import { actions as testActions } from './test'
import { actions as resultActions } from './result'
import { waitToNext } from '../utils/utils'

const types = {
  CHANGE_STAGE: 'CHANGE_STAGE',
  SET_TOKEN: 'SET_TOKEN',
  SET_TEST_TYPE: 'SET_TEST_TYPE'
}

export const actions = {
  changeStage(stage) {
    return { type: types.CHANGE_STAGE, payload: stage }
  },
  setToken(token) {
    return { type: types.SET_TOKEN, payload: token }
  },
  setTestType(type, trace) {
    return { type: types.SET_TEST_TYPE, payload: { testType: type, trace } }
  },
  createPreTest(type) {
    return async dispatch => {
      const obj = {
        parallels: 2,
        request_count: 2,
        stage: 0,
        type
      }
      try {
        const data = await fetchCreate(obj)
        const { questions, runtime, token } = data
        dispatch(
          testActions.setTestData({
            preWord: null,
            curWord: questions[0],
            nextWord: questions[1],
            runtime
          })
        )
        dispatch(testActions.startCurTest(+new Date()))
        dispatch(this.changeStage(0))
        dispatch(
          resultActions.setData({
            subject: '',
            banners: []
          })
        )
        dispatch(this.setToken(token))
        dispatch(testActions.setCount(0))
        dispatch(testActions.setTotalCount(8))
      } catch (err) {
        console.log(err)
        if (confirm(err.message + '，确认重试？')) {
          dispatch(this.createPreTest(type))
        }
      }
    }
  },
  createTest() {
    return async (dispatch, getState) => {
      const {
        app: { token }
      } = getState()
      const obj = {
        answer: null,
        request_count: 2,
        request_word: null,
        stage: 1,
        token
      }
      try {
        // eslint-disable-next-line
        const [_, data] = await Promise.all([waitToNext(), fetchNext(obj)])
        // const data = await fetchNext(obj)
        const { questions, runtime } = data
        dispatch(this.changeStage(1))
        dispatch(testActions.setUpload(false))
        dispatch(
          testActions.setTestData({
            preWord: null,
            curWord: questions[0],
            nextWord: questions[1],
            runtime
          })
        )
        dispatch(testActions.setCount(0))
        dispatch(testActions.setTotalCount(30))
        dispatch(testActions.startCurTest(+new Date()))
      } catch (err) {
        console.log(err)
        if (confirm(err.message + '，确认重试？')) {
          dispatch(this.createTest())
        }
      }
    }
  }
}

const initialState = {
  token: '',
  trace: '',
  testType: 1, // 默认是阅读测试，2表示听力测试
  stage: -1 // 当前的阶段， 0表示预备测试阶段， 1表示正式测试阶段, 2表示测试完成阶段
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.CHANGE_STAGE:
      return {
        ...state,
        stage: action.payload
      }
    case types.SET_TOKEN:
      return {
        ...state,
        token: action.payload
      }
    case types.SET_TEST_TYPE:
      return {
        ...state,
        ...action.payload
      }
    default:
      return state
  }
}
